var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('img',{attrs:{"src":require("@/assets/gps_logo.png"),"alt":"Main logo","height":"400"}})])
}]

export { render, staticRenderFns }